import { render, staticRenderFns } from "./MedicinalFrequency.vue?vue&type=template&id=0457c8fa&scoped=true&"
import script from "./MedicinalFrequency.vue?vue&type=script&lang=js&"
export * from "./MedicinalFrequency.vue?vue&type=script&lang=js&"
import style0 from "./MedicinalFrequency.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MedicinalFrequency.vue?vue&type=style&index=1&id=0457c8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457c8fa",
  null
  
)

export default component.exports